import React from 'react';
import '../styles/HeroSection.css';

const HeroSection: React.FC = () => {
  return (
    <section className="hero">
      <img src={require('../assets/home-1.jpg')} alt="Hot Pot" className="hero-image" />
    </section>
  );
}

export default HeroSection;
